export const AUTH_REQUEST = "auth_request";
export const AUTH_SUCCESS = "auth_success";
export const AUTH_ERROR = "auth_error";
export const AUTH_LOGOUT = "auth_logout";
export const AUTH_REGISTER_SUCCESS = "auth_register_success";
export const COMMON_SET_SNACK = "common_setSnack";
export const COMMON_SET_LAYOUT = "common_setLayout";
export const COMMON_SET_PAGE_TITLE = "common_setPageTitle";
export const COMMON_SET_LOADING = "common_setLoading";

// config page
export const COMMON_GET_CONFIG_PAGE = "common_get_config_page";

export const COMMON_SET_COIN = "common_set_coin";
export const COMMON_SET_GEM = "common_set_gem";
export const COMMON_SET_PERCENT_PRESENTER = "common_set_percent_presenter";
